import { service } from '../../helpers/http'
import state from './store/state'
import mutations from './store/mutations'
import * as baseActions from './store/actions'

const ActionAlgorithmRunsAmbienceBalanceApply = ({ dispatch }, payload) => {
  const body = {}
  if (payload && payload.mode) {
    body.mode = payload.mode
  }
  return service({
    module: 'algorithmRuns',
    action: 'applyAmbienceBalanceRun',
    params: { id: payload.id },
    payload: body,
  })
}

const ActionAlgorithmRunsAmbienceAllocationApply = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'applyAmbienceAllocationRun',
    params: { id: payload.id },
    payload: {},
  })
}

const ActionAlgorithmRunsApplyStatus = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'applyStatusRun',
    params: { id: payload.id },
    payload: {},
  })
}

const ActionAlgorithmRunsApplications = ({ dispatch }, payload) => {
  return service({
    module: 'algorithmRuns',
    action: 'listApplications',
    payload,
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  actions: {
    ...baseActions,
    ActionAlgorithmRunsAmbienceBalanceApply,
    ActionAlgorithmRunsAmbienceAllocationApply,
    ActionAlgorithmRunsApplyStatus,
    ActionAlgorithmRunsApplications,
  },
}
